import { render, staticRenderFns } from "./FormPerInvoice.vue?vue&type=template&id=cf68f1da&"
import script from "./FormPerInvoice.vue?vue&type=script&lang=js&"
export * from "./FormPerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./FormPerInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports